export default __webpack_public_path__ + "static/media/Bitmap@2x.21660a81.png";